import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux' 
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { clearUserUpdateMsg } from '../actions/profileAction'
import { addCategoryAction,clearMasterAddMsg, getCategoriesAction , updateCategoryAction, deleteMasterAction } from '../actions/masterAction'
import MasterEditPopup from './masterEditPopup'
import MasterTrashPopup from './masterTrashPopup';
import AddCategory from './addCategory';
import MasterEditCatPopup from './masterEditCatPopup';


const { SearchBar } = Search;



class CategoryList extends Component {

   constructor(props){

      super(props)
this.state = {
  editData:'',
  trashId:'',
  isOpentrash:false,
  isOpen:false,
  currentPage: 1,
  perPage: 10
}

this.formatAction = this.formatAction.bind(this)
this.formatSlno = this.formatSlno.bind(this)
this.formatStatus = this.formatStatus.bind(this)
this.formatParent = this.formatParent.bind(this)
this.saveStore = this.saveStore.bind(this)
this.updateCategory = this.updateCategory.bind(this)
this.trashStore = this.trashStore.bind(this)
this.editStore = this.editStore.bind(this)
this.deleteStore = this.deleteStore.bind(this)
this.onPageChange = this.onPageChange.bind(this)
this.onSizePerPageChange = this.onSizePerPageChange.bind(this)
this.closeModal = this.closeModal.bind(this)

   }

   onPageChange = (page, perPage) => {

 

    this.setState({
      currentPage: page,
      perPage: perPage
    })


  };
  onSizePerPageChange = ( perPage, page,) => {

 

    this.setState({
      currentPage: page,
      perPage: perPage
    })


  };

   formatAction=(row)=>{

    let sendData = {name:row.ctg_name, description: row.ctg_desc, id: row.id, status: row.ctg_active, parent:row.ctg_parent}

      return (
     <span> <a title="edit" onClick ={(e)=>{this.editStore(e,sendData);}} href="#"> <i className="fa fa-pencil"></i></a>{' '}&nbsp;&nbsp;
     {row.ctg_active?<a  title="Suspend" onClick ={(e)=>{this.deleteStore(e,row.id);}} href="#"> <i className="fa fa-ban"></i></a>:''}
     
     </span>
      )
   }
   formatSlno = (cell, row, rowIndex, ) => {
    const { currentPage, perPage } = this.state

   let slNo=rowIndex+1

  
    slNo = (currentPage * perPage + slNo) - perPage
 
   
     

    
    return slNo


  }
   formatStatus=(cell)=>{

    if(cell ===0){
      return "Suspended"
    }else if (cell ===1){
      return "Active"
    }
  }
   formatParent=(cell)=>{
const {categories} = this.props
let parent ="---";
categories&&categories.map((cat)=>{
if(cat.id === cell){
  parent = cat.ctg_name
}

})
    return parent
  }
 
   saveStore=(formData)=>{

    this.props.addCategory(formData)
   }
   updateCategory=(formData)=>{

      this.props.updateCategory(formData)


    setTimeout(() => {
      this.setState({
        editData:{},
        isOpen:false
      })
    }, 1000);


   }
  
   trashStore=(id)=>{

    this.props.deleteStoreFn(id,'cat')

    setTimeout(() => {
      this.setState({
        trashId:'',
        isOpentrash:false
      })
    }, 1000);


   }
   editStore=(e,data)=>{

    
e.preventDefault()
    this.setState({
      editData:data,
      isOpen:true
    })
   }
   deleteStore=(e,id)=>{

    
e.preventDefault()
    this.setState({
      trashId:id,
      isOpentrash:true
    })
   }
   closeModal=()=>{

    this.setState({
      editData:{},
      isOpen:false,
      trashId:'',
      isOpentrash:false
    })
   }

 


  componentDidMount(){



  }

  componentWillReceiveProps(nextProps){



  }
  componentWillUnmount(){

    this.props.clearMasterAddMsg()
  }
    render(){
      const columns = [{
         dataField: 'id',
         text: '#',
         formatter: this.formatSlno

       }, {
         dataField: 'ctg_name',
         text: 'Category'
       },{
        dataField: 'ctg_desc',
        text: 'Description'
      },{
        dataField: 'ctg_parent',
        text: 'Parent',
        formatter: (cell) => this.formatParent(cell)
      },
      {
        dataField: 'ctg_active',
        text: 'Status',
        formatter: (cell) => this.formatStatus(cell)

      },
        
        {
         dataField: 'id',
         text: 'Action',
         formatter: (cell, row) => this.formatAction(row)
       },
      
      ];

      const {categories} = this.props
      const {editData, isOpen, isOpentrash, trashId} = this.state
      const options = {
        onPageChange: this.onPageChange,
        onSizePerPageChange: this.onSizePerPageChange
  
      };
return(
  

  <div  >

    <AddCategory saveStore={this.saveStore} catList={categories} />

{categories&&<ToolkitProvider
 bootstrap4 keyField='id'
 data={ categories }
 columns={ columns } 

 search
>
{props =>
(<div>
<SearchBar { ...props.searchProps } />
        <hr />
<BootstrapTable 
classes="table-responsive"
 { ...props.baseProps }  pagination={ paginationFactory(options) }
/>
</div>)}

 </ToolkitProvider>}


 <MasterEditCatPopup   isOpen={isOpen} editData={editData}  closeModal={this.closeModal} onUpdated={this.updateCategory} key={editData.id} catList={categories}  />


<MasterTrashPopup isOpentrash={isOpentrash} trashId={trashId} closeModal={this.closeModal} onDelete={this.trashStore} key={trashId}  />   </div>


          
        ) }

}

const mapStateToProps = state => ({

  categories: state.categoryMasterReducer.category,


 
 })
 const mapDispatchToProps = dispatch => ({
  
  clearMasterAddMsg:()=>dispatch(clearMasterAddMsg()),
  addCategory:(formData)=>dispatch(addCategoryAction(formData)),
  updateCategory:(formData)=>dispatch(updateCategoryAction(formData)),
  deleteStoreFn:(id,type)=>dispatch(deleteMasterAction(id,type)),
  getCategoryList: () => dispatch(getCategoriesAction()),

 
 
 })
 export default connect(mapStateToProps, mapDispatchToProps)(CategoryList)